<template>
  <div
    class="panel-row-without-selector-res mb-3 py-3 gray border-radius--light border-gray"
  >
    <div class="col-md-3 pt-0 info">
      <slot name="firstColumn" />
    </div>
    <div class="col pt-xs-4 info">
      <slot name="secondColumn" />
    </div>
    <div class="col-md-2 pt-xs-4 info">
      <slot name="thirdColumn" />
    </div>
    <div class="col pt-xs-4 info">
      <slot name="fourthColumn" />
    </div>
    <div v-if="actions && actions.length" class="col info text-right pt-3">
      <button
        class="btn btn-dropdown-actions dropdown-toggle pt-1"
        type="button"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        Acciones
      </button>
      <div class="dropdown-menu dropdown-menu-right pb-0">
        <a
          v-for="action in actions"
          :key="action.name"
          class="drop-item"
          href="javascript:void(0)"
          @click="action.click"
        >
          <i :class="`fas ${action.icon} pr-1`" />
          <span :data-node="node">{{ action.name }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Dropdown from "dropdown";

export default {
  name: "DocumentLayout",
  components: {
    Dropdown
  },
  props: {
    actions: {
      type: Array,
      default: () => []
    },
    node: {
      type: Number,
      default: 0
    },
    isRow: {
      type: Boolean,
      default: true
    },
    inDropdown: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped>
.btn-dropdown-actions {
  border-color: #2b9d71 !important;
}

.drop-item {
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #11291b;
  text-align: inherit;
  white-space: nowrap;
  display: block;
  padding: 0.29rem 1.5rem;
  clear: both;
  text-decoration: none !important;
}
</style>
